
export const enStyle = () => {
    let style = document.createElement('style');

    style.innerHTML = ` 
    * { 
        direction: ltr !important;
        text-align: left;
    }
    body {
        direction: ltr !important;
        text-align: left;
        font-family: Montserrat !important;
    }
    .search_box {
        right: 13%;
        left: auto;
    }
    .home_company_views {
        right: 15px !important;
        left: auto !important;
    }
    .slick-track {
        margin-left: 0;
        margin-right: auto;
    }
      
    ol, ul {
        padding-left: 1rem;
    }
    
    .navbar-nav {
        flex: 1;
    }

    .subscribe .subscribe-form button {
        right: 2px;
        left: auto;
    }

    .loginLang {
        right: 1%;
        left: auto;
    }

    .Toastify__toast {
        direction: ltr !important;
    }

    .dashboard_sidebar {
        left: 0;
        right: auto;
    }

    .dashboard_container {
        margin: auto;
        width: calc(100vw - 260px);
        margin: auto;
        margin-left: auto;
        margin-right: 0;
        padding: 0 1rem;
    }

    .dashboard_sidebar .offcanvas-header {
        direction: rtl !important;
    }

    .dashboard_nav img {
        margin-left: 0.3rem;
        margin-right: 1rem;
    }

    .offset-md-3 {
        margin-left: 25%;
        margin-right: auto;
    }

    .offset-md-2, .offset-lg-2 {
        margin-left: 16.66666667%;
        margin-right: auto;
    }
    .offset-md-9 {
        margin-left: 75%;
        margin-right: auto;
    }
    .searchIcon {
        right: 3.8% !important;
    }
    .home_announcement_item_description > * , .announcement_container .announcement .announcement_description > * {
        text-align: left !important;
    }
    .homepage_notifications_btn {
        right: 8px;
        left: auto;
    }
    .breadcrumb-item + .breadcrumb-item::before {
        float: left;
        padding-right: .5rem;
    }
    .home_item h1 {
        text-align: left !important;
    }
    .form-floating > label {
        left: 0;
        right: auto;
    }
    .form-select {
        background-position: right .75rem center;
    }
    .company-wrapper .company-cover .company-avatar {
        right: 5%;
        left: auto;
    }
    .dashboard_navbar .navbar .signout_icon {
        margin-top: -.2rem !important;
    }
    .dropdown-toggle::after {
        margin-left: .255em;
        margin-right: 0;
    }
    .dashboard_nav a {
        font-size: .79rem;
    }
    .dashboard-create h6 {
        font-size: .9rem;
    }
    .rdw-dropdown-carettoopen, .rdw-dropdown-carettoclose {
        right: 10%;
        left: auto;
    }

    @media (max-width: 990px) {
        .search_box {
            right: 5%;
            left: auto;
        }
        .res_hide_sidebar {
            transform: translateX(-100%);
        }
        .show_sidebar {
            left: 8%;
            right: auto;
        }
        .dash_slider_container .slick-next {
            left: auto !important;
            right: 5% !important;
        }
        .dash_slider_container .slick-prev {
            left: auto !important;
            right: 14% !important;
        }
        .offset-md-3 {
            margin-right: .2rem !important;
            margin-left: .2rem !important;
        }
        .offset-md-3 {
            margin-right: .2rem !important;
            margin-left: .2rem !important;
        }
        .offset-md-2, .offset-lg-2 {
            margin-right: .2rem !important;
            margin-left: .2rem !important;
        }
        .offset-md-9 {
            margin-right: .2rem !important;
            margin-left: .2rem !important;
        }
    }
     
    `;
    document.head.appendChild(style);
}